<script>
export default {
  name: 'ErrorV2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 26,
    },
    color: {
      type: String,
      default: '#56AF79',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.04 5.62626C10.649 5.23526 10.017 5.23526 9.62601 5.62626L8.33301 6.91926L7.04001 5.62626C6.64901 5.23526 6.01701 5.23526 5.62601 5.62626C5.23501 6.01726 5.23501 6.64926 5.62601 7.04026L6.91901 8.33326L5.62601 9.62626C5.23501 10.0173 5.23501 10.6493 5.62601 11.0403C5.82101 11.2353 6.07701 11.3333 6.33301 11.3333C6.58901 11.3333 6.84501 11.2353 7.04001 11.0403L8.33301 9.74726L9.62601 11.0403C9.82101 11.2353 10.077 11.3333 10.333 11.3333C10.589 11.3333 10.845 11.2353 11.04 11.0403C11.431 10.6493 11.431 10.0173 11.04 9.62626L9.74701 8.33326L11.04 7.04026C11.431 6.64926 11.431 6.01726 11.04 5.62626Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.8334 7.47833H15.8309C15.3709 7.47917 14.9992 7.85417 15 8.31417C15.005 10.095 14.3167 11.7708 13.0609 13.0342C11.8059 14.2967 10.1334 14.995 8.35254 15H8.33337C6.5592 15 4.89087 14.3117 3.63254 13.0608C2.37004 11.805 1.67171 10.1333 1.66671 8.3525C1.66171 6.57167 2.35004 4.895 3.60587 3.6325C4.86087 2.37 6.53337 1.67167 8.31421 1.66667C8.83587 1.675 9.38504 1.7275 9.90254 1.8525C10.3475 1.95917 10.8 1.68417 10.9075 1.2375C11.0159 0.79 10.74 0.34 10.2934 0.231667C9.6467 0.0766667 8.97171 0.01 8.30921 0C6.08337 0.00666667 3.99337 0.879166 2.42421 2.4575C0.854205 4.03583 -0.00662823 6.13083 3.84336e-05 8.3575C0.0067051 10.5833 0.879205 12.6733 2.45754 14.2425C4.03004 15.8067 6.11587 16.6667 8.33337 16.6667H8.35754C10.5834 16.66 12.6734 15.7875 14.2425 14.2092C15.8125 12.6308 16.6734 10.535 16.6667 8.30917C16.6659 7.85 16.2925 7.47833 15.8334 7.47833Z"
      :fill="color"
    />
  </svg>
</template>
